// vanillaNav - Peter Ballasiotes
// Version 1.4

// EMsize Function (If needed)
function EMsize() {
  return (
    (window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth) /
    parseFloat(getComputedStyle(document.querySelector("html")).fontSize)
  )
}

function vanillaNav(customOptions) {
  var options = {
    selector: "#nav",
    navContainer: "#hd",
    breakpointMax: 64,
    toggle: ".nav-toggle",
    close: ".nav-close",
    navTag: "nav",
    collapsible: "ul",
    triggerParent: "li",
    trigger: "a",
    openClass: "open",
  }

  for (var property in customOptions) {
    options[property] = customOptions[property]
  }

  var collap
  var scrollTop
  var screenWidth
  var distTop = 0
  var navOuter = document.querySelector(options.selector)
  var navElem = document.querySelectorAll(
    options.selector + " " + options.navTag + " " + options.trigger
  )
  var navContainer = document.querySelector(options.navContainer)
  var theToggle = document.querySelector(options.toggle)
  var theClose = document.querySelector(options.close)

  window.addEventListener("load", onLoadFunction)
  window.addEventListener("resize", onResizeFunction)
  window.addEventListener("scroll", navClasses)

  function onLoadFunction() {
    onResizeFunction()
    navClasses()
  }
  function onResizeFunction() {
    screenWidth = EMsize()
  }

  if (theToggle !== null) {
    theToggle.addEventListener("click", function (e) {
      e.preventDefault()
      if (navOuter.classList.contains(options.openClass)) {
        var elements = document.querySelectorAll(
          options.selector + " " + options.navTag + " " + options.triggerParent
        )
        for (var i = 0; i < elements.length; i++) {
          elements[i].classList.remove(options.openClass)
        }
      }
      theToggle.classList.toggle(options.openClass)
      navOuter.classList.toggle(options.openClass)
      document.querySelector("body").classList.toggle(options.openClass)
    })
  }
  if (theClose !== null) {
    theClose.addEventListener("click", function (e) {
      e.preventDefault()
      navOuter.classList.toggle(options.openClass)
    })
  }

  // Show hide sticky navbar in mobile
  function navClasses() {
    scrollTop = window.scrollY
    var scrollTopValue
    if (screenWidth > 48) {
      scrollTopValue = 10
    } else {
      scrollTopValue = 10
    }

    if (scrollTop < scrollTopValue) {
      document.body.classList.add("pagetop")
    } else {
      document.body.classList.remove("pagetop")
    }

    if (document.body.getBoundingClientRect().top > distTop) {
      setTimeout(function () {
        document.body.classList.add("scrollingup")
        document.body.classList.remove("scrollingdown")
      }, 130)
    } else {
      if (!navOuter.classList.contains("open")) {
        setTimeout(function () {
          document.body.classList.add("scrollingdown")
          document.body.classList.remove("scrollingup")
        }, 130)
      }
    }
    distTop = document.body.getBoundingClientRect().top
  }

  // Main Nav Function Toggle classes and prevent defaults
  for (var i = 0; i < navElem.length; i++) {
    navElem[i].addEventListener("click", function (e) {
      collap = this.parentNode.getElementsByTagName(options.collapsible)
      if (screenWidth < options.breakpointMax && collap.length > 0) {
        e.preventDefault()
        this.parentNode.classList.toggle(options.openClass)
      }
    })
  }
}
